import React, { Suspense } from 'react';
import { getAutomationActionFormComponent } from '../actionForms';
import Skeleton from '@components/Job/components/Skeleton';

const AutomationActionsEditor = ({
    selectedAction,
    category,
    contextId,
    actionValue,
    onChangeActionValue,
    readOnly = false,
    actionResources = null,
    actionResourcesError = null,
}) => {
    const FormComponent = getAutomationActionFormComponent(selectedAction?.id);

    if (!FormComponent) {
        return null;
    }

    return (
        <Suspense fallback={<Skeleton type={Skeleton.TYPES.AUTOMATION_ACTION_EDITOR} />}>
            <FormComponent
                value={actionValue}
                onChange={onChangeActionValue}
                readOnly={readOnly}
                category={category}
                contextId={contextId}
                actionResources={actionResources}
                actionResourcesError={actionResourcesError}
            />
        </Suspense>
    );
};

export default AutomationActionsEditor;
